import { useInfiniteQuery } from '@tanstack/react-query';
import { getAgentRakeShare } from '../rake.service';
import { AgentRakeQuery } from '@/services/rake/rake.types';

const agentsPerFetch = 20;

const useGetAgentRakeShare = (agentRakeQuery: AgentRakeQuery) => {
  return useInfiniteQuery({
    queryKey: ['rake-agent-share', agentRakeQuery],
    queryFn: ({ pageParam }) => getAgentRakeShare({ ...agentRakeQuery, ...pageParam }),
    initialPageParam: { paginationOptions: { skip: 0, take: agentsPerFetch } },
    getNextPageParam: (_, pages) => {
      return {
        paginationOptions: {
          skip: pages.flatMap((e) => e.data).length,
          take: agentsPerFetch,
        },
      };
    },
    refetchOnWindowFocus: true,
    refetchInterval: 5000,
  });
};

export default useGetAgentRakeShare;
